import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { TProgramClassifications } from '../types';

export const getProgramsClassifications = async (): Promise<TProgramClassifications[]> => {
  return mediaManagerClient.get('/api/v1/classifications').then(({ data }) => data);
};
type QueryFnType = typeof getProgramsClassifications;

type UseProgramsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetProgramsClassifications = ({ config }: UseProgramsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['program-classifications'],
    queryFn: getProgramsClassifications,
  });
};
